import type { FunctionComponent } from "react";

import { tracking } from "~/data";
import { useMyNews } from "~/lib/hooks";

import ArrowIcon from "./icon-arrow.svg";
import { Container, Content, Link, Title } from "./styles";

type Props = {
  className?: string;
};
export const MyNewsPromotionWidget: FunctionComponent<Props> = ({ className }) => {
  const { initialHasEnoughFollowedItems } = useMyNews();

  return (
    <Container className={className}>
      <Title>
        {initialHasEnoughFollowedItems ? (
          "My Daily 5 must-reads"
        ) : (
          <>
            Get more with <i>my</i>NEWS
          </>
        )}
      </Title>
      <Content>
        {initialHasEnoughFollowedItems
          ? "Curating the most important articles that matter to you"
          : "A personalised news feed of stories that matter to you"}
      </Content>
      <Link
        pathname="/mynews"
        query={{ module: tracking.module.MyNewsText, pgtype: tracking.pageType.Article }}
      >
        Learn more
        <ArrowIcon />
      </Link>
    </Container>
  );
};
MyNewsPromotionWidget.displayName = "MyNewsPromotionWidget";
